import * as React from "react";
import { useState, useEffect } from "react";
import "./style.css";
import { Typography, Select } from "antd";
import "antd/dist/antd.css";
import FormBatchWalletStacking from "./FormWalletStacking";
import { validationErrors } from "../../../utils/Helpers";
import Pageloader from "../../../components/loader";
import * as zoneActions from "../../../redux/actions/zone.actions";
import * as walletStackingActions from "../../../redux/actions/batch.action";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const { Option } = Select;
const { Title } = Typography;

const BatchWalletStacking = (props) => {
  const pagename = "Batch Wallet & Stacking";
  const [postDataM, setPostDataM] = useState(null);
  const [postDataO, setPostDataO] = useState(null);
  const [postDataR, setPostDataR] = useState(null);
  const [loading, setLoading] = useState(false);
  const [zoneId, setZoneId] = useState(props.stackingSelectedZone);

  useEffect(() => {
    postLists();
  }, []);
  const postLists = async () => {
    try {
      setLoading(true);
      await props.zoneActions.getZoneListAction();
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const typeManual = "manual";
  const typeOrdersGRiders = "auto_more_tasks";
  const typeRidersGOrders = "auto_more_riders";
  const handleChangeZone = async (value) => {
    try {
      setLoading(true);
      setZoneId(value);
      await props.walletStackingActions.stackingSelectedZoneAction(value);
      await props.walletStackingActions.getWalletStackingManualAction(
        value,
        typeManual
      );
      await props.walletStackingActions.getWalletStackingOrderGRiderAction(
        value,
        typeOrdersGRiders
      );
      await props.walletStackingActions.getWalletStackingRiderGOrderAction(
        value,
        typeRidersGOrders
      );
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.stackingMData) {
      const initialValuesM = {
        defaultData: filterdata(props.stackingMData),
      };
      setPostDataM(initialValuesM);
    }
  }, [props.stackingMData]);

  useEffect(() => {
    if (props.stackingOData) {
      const initialValuesO = {
        defaultData: filterdata(props.stackingOData),
      };
      setPostDataO(initialValuesO);
    }
  }, [props.stackingOData]);

  useEffect(() => {
    if (props.stackingRData) {
      const initialValuesR = {
        defaultData: filterdata(props.stackingRData),
      };
      setPostDataR(initialValuesR);
    }
  }, [props.stackingRData]);

  const filterdata = (data) => {
    const valuesDataconvert = [];
    data.map((item) => {
      const valueObj = {
        batchLevel: item.batch.batchLevel,
        batch: item.batch.id,
        cash_limit: item.cashLimit,
        order_value_limit: item.orderValueLimit,
        stacking_limit: item.stackingLimit,
        stackingDistance: item.stackingDistance,
        zone: zoneId,
        type: item.type,
        assignmentInterval: item.assignmentInterval ? item.assignmentInterval : 0,
      };
      valuesDataconvert.push(valueObj);
    });
    return valuesDataconvert;
  };

  const onFinish = async (data, type) => {
    try {
      setLoading(true);
      await props.walletStackingActions.putWalletStackingAction(
        type,
        zoneId,
        data.defaultData
      );
    } catch (e) {
      validationErrors(e);
    } finally {
      setLoading(false);
      handleChangeZone(zoneId);
    }
  };
  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>{pagename}</Title>
        </div>
        <div className="pch">
          <label>Please select Zone</label>
          <Select
            loading={loading}
            defaultValue={zoneId}
            Value={zoneId}
            placeholder="Please select Zone"
            onChange={handleChangeZone}
            style={{
              minWidth: 300,
            }}
          >
            {props.zoneData &&
              props.zoneData.map((item) => {
                return <Option key={item.id}>{item.zoneName}</Option>;
              })}
          </Select>
        </div>
      </div>
      <div className="p-content">
        <Title level={3}>Manual</Title>
        {loading ? (
          <Pageloader />
        ) : (
          <FormBatchWalletStacking
            initialValues={postDataM}
            onFinish={(data, type) => onFinish(data, type)}
            loading={loading}
            type={typeManual}
          />
        )}
      </div>
      <div className="p-content">
        <Title level={3}>Orders greater than riders</Title>
        {loading ? (
          <Pageloader />
        ) : (
          <FormBatchWalletStacking
            initialValues={postDataO}
            onFinish={(data, type) => onFinish(data, type)}
            loading={loading}
            type={typeOrdersGRiders}
          />
        )}
      </div>
      <div className="p-content">
        <Title level={3}>Riders greater than orders</Title>
        {loading ? (
          <Pageloader />
        ) : (
          <FormBatchWalletStacking
            initialValues={postDataR}
            onFinish={(data, type) => onFinish(data, type)}
            loading={loading}
            type={typeRidersGOrders}
          />
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    stackingSelectedZone: state.BatchReducer.stackingSelectedZone,
    stackingMData: state.BatchReducer.stackingMData,
    stackingOData: state.BatchReducer.stackingOData,
    stackingRData: state.BatchReducer.stackingRData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    walletStackingActions: bindActionCreators(walletStackingActions, dispatch),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BatchWalletStacking);
